export class LegalType {
  id: string;
  name: string;

  constructor(legalType: Partial<LegalType>) {
    this.id = legalType.id;
    this.name = legalType.name;
  }
}
